import { baseApi } from "./index";

export const languageApi = baseApi.injectEndpoints({
    endpoints: (builder) => ({
        getLanguage: builder.query({
            query: ({ page = "/", locale }) => ({
                url: "/language",
                method: "GET",
                params: {
                    page,
                    locale,
                },
            }),
            providesTags: ["Language"],
        }),
    }),
});

export const {
    useGetLanguageQuery,
} = languageApi;
